import React, { useState } from 'react'
import Collapse from 'blocks.simple/collapse/collapse'
import translate from 'core/translate'
import { cn } from 'ethcss'
import { grid } from '../../../theme'
import styles from '../settings.jcss'
import Button from '../../../blocks.simple/button/button'
import { ApiKeys } from './__apiKeys/apiKeys'
import { SwitchButton } from '../../../atoms/SwitchButton'
import helpers from '../../../core/helpers'
import { RootStateOrAny, useDispatch, useSelector } from 'react-redux'
import { updateUserSettings } from '../../../blocks.app/user/user.state'

export const ForDevelopers = () => {
    const [apiKeysOpened, setApiKeysOpened] = useState<boolean>(false)
    const user: any = useSelector<RootStateOrAny>((state) => state.user.data)
    const dispatch = useDispatch()

    const openApiKeys = () => {
        setApiKeysOpened(true)
    }
    const closeApiKeys = () => {
        setApiKeysOpened(false)
    }

    return (
        <Collapse title={() => translate('forDevelopers')} className={cn(styles.background, grid.mb_md)}>
            <div className={cn(grid.row)}>
                <div className={styles.apiKeys}>
                    <div>{translate('apiKeysAccess')}</div>
                    <div>
                        <Button mod={'fill'} onClick={openApiKeys}>
                            {translate('open')}
                        </Button>
                    </div>
                    <ApiKeys onClose={closeApiKeys} opened={apiKeysOpened} />
                </div>
            </div>
            {/*{helpers.isAvailable({ key: 'distributiveShowDirectLinkSettings', action: 'read' }) && (*/}
            {/*    <div className={grid.row} style={{ marginTop: 30 }}>*/}
            {/*        <div className={grid.mr_miniMiddle}>{translate('distributiveLinksAsUnsafeView')}</div>*/}
            {/*        <SwitchButton*/}
            {/*            onChange={() => {*/}
            {/*                dispatch(*/}
            {/*                    updateUserSettings({*/}
            {/*                        data: { distributiveShowDirectLink: !user.settings.distributiveShowDirectLink },*/}
            {/*                        isSaveSettings: true,*/}
            {/*                    })*/}
            {/*                )*/}
            {/*            }}*/}
            {/*            checked={user.settings.distributiveShowDirectLink}*/}
            {/*            disabled={!helpers.isAvailable({ key: 'moderation', action: 'update' })}*/}
            {/*        />*/}
            {/*    </div>*/}
            {/*)}*/}
        </Collapse>
    )
}
